import { applyDecorators, Get } from '@nestjs/common';
import {
  ApiForbiddenResponse,
  ApiInternalServerErrorResponse,
  ApiNotFoundResponse,
  ApiOkResponse,
  ApiUnauthorizedResponse,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';

import { Roles } from '../../auth';

export const DownloadResponse = (path: string | string[], roles?: string[]) =>
  applyDecorators(
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiNotFoundResponse({ description: 'Not Found (404)' }),
    ApiOkResponse({ description: 'OK (200)' }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    Get(path),
    Roles(roles)
  );
